exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-by-component[data-v-773ecf68] {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.order-by-component[data-v-773ecf68]:hover {\n  text-decoration: underline;\n}\n.sort-icon-color[data-v-773ecf68] {\n  color: #1890ff;\n}", ""]);

// exports
